// NPM Imports
import React from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../revvComponents";

// Components Imports
import QuickReviewIcon from "../QuickReview/QuickReviewIcon";

// Actions Imports

// Services Imports

// Internal Imports
import { TOOLPANE } from "../../constants";

// Destructuring
const { TOOLPANE_TTITLE } = TOOLPANE;
const {
  DOC_COMPONENTS,
  DYNAMIC_FIELDS,
  SIGNATURE_COMPONENTS,
  DOC_SIGNATURE_COMPONENTS,
} = TOOLPANE_TTITLE;

// Declaration
const TEMPLATE = "TEMPLATE";
const DOCUMENT = "DOCUMENT";

export default function ToolPaneListItem({
  foundSignatureBlockStatus,
  isOpen,
  mode,
  option,
  onChangeView,
  templateStatus,
  view,
}) {
  // mapStateToProps
  const isLocked = useSelector(state => state.DocumentStore.document.isLocked);
  const showForm = useSelector(state => state.DocumentStore.document.showForm);

  // cases to hide DOC_COMPONENTS icon
  if (option.title === DOC_COMPONENTS || option.title === DYNAMIC_FIELDS) {
    if (
      mode === DOCUMENT &&
      (isLocked || showForm) &&
      !foundSignatureBlockStatus
    ) {
      return null;
    }
    if (mode === TEMPLATE && templateStatus !== "DRAFT") {
      return null;
    }
  } else if (
    (option.title === SIGNATURE_COMPONENTS ||
      option.title === DOC_SIGNATURE_COMPONENTS) &&
    isLocked
  ) {
    return null;
  }
  if (!(isLocked && option.hideOnViewMode)) {
    return option.hasToolTip ? (
      <Tooltip placement="left" overlay={`${option.toolTipMessage}`}>
        <div
          data-test={`toolpanewrapper-apps-${option.title}-icon`}
          key={option.title}
          className={`toolpanewrapper-apps ${
            option.title === view && isOpen ? "active" : null
          }`}
          id={`${option.title}-icon`}
          onClick={() => onChangeView(option.title, option.gtmAction)}
          tabIndex="0"
          onKeyDown={() => {}}
          role="button">
          {option.title === "quick-review" ? (
            <div className={`toolpanewrapper-ico ${option.title}`}>
              <QuickReviewIcon active={option.title === view && isOpen} />
              <div className="option-title">{option.toolTipLabel}</div>
            </div>
          ) : (
            <div className={`toolpanewrapper-ico ${option.title}`}>
              <FontAwesomeIcon
                icon={[
                  `${option.iconType ? option.iconType : "far"}`,
                  `${option.ico}`,
                ]}
              />
              <div className="option-title">{option.toolTipLabel}</div>
              {option.hasNewTag && (
                <span className="toolpane-new-tag">New</span>
              )}
            </div>
          )}
        </div>
      </Tooltip>
    ) : (
      <div
        data-test={`toolpanewrapper-apps-${option.title}-icon`}
        key={option.title}
        className={`toolpanewrapper-apps ${
          option.title === view && isOpen ? "active" : null
        }`}
        id={`${option.title}-icon`}
        onClick={() => onChangeView(option.title, option.gtmAction)}
        tabIndex="0"
        onKeyDown={() => {}}
        role="button">
        {option.title === "quick-review" ? (
          <div className={`toolpanewrapper-ico ${option.title}`}>
            <QuickReviewIcon active={option.title === view && isOpen} />
            <div className="option-title">{option.toolTipLabel}</div>
          </div>
        ) : (
          <div className={`toolpanewrapper-ico ${option.title}`}>
            <FontAwesomeIcon
              icon={[
                `${option.iconType ? option.iconType : "far"}`,
                `${option.ico}`,
              ]}
            />
            <div className="option-title">{option.toolTipLabel}</div>
            {option.hasNewTag && <span className="toolpane-new-tag">New</span>}
          </div>
        )}
      </div>
    );
  }
  return <div key={option.title} />;
}
